import { axios, API } from './config';

export const staffAPI = {
  getAll: async (role = null, status = null) => {
    const params = {};
    if (role) params.role = role;
    if (status) params.status = status;
    const response = await axios.get(`${API}/staff`, { params });
    return response.data;
  },
  
  getById: async (id) => {
    const response = await axios.get(`${API}/staff/${id}`);
    return response.data;
  },
  
  create: async (data) => {
    const response = await axios.post(`${API}/staff`, data);
    return response.data;
  },
  
  update: async (id, data) => {
    const response = await axios.put(`${API}/staff/${id}`, data);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await axios.delete(`${API}/staff/${id}`);
    return response.data;
  },
  
  getAllAssignments: async (startDate = null, endDate = null) => {
    const params = {};
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;
    const response = await axios.get(`${API}/staff/assignments/all`, { params });
    return response.data;
  },
  
  getAssignments: async (contractId) => {
    const response = await axios.get(`${API}/staff/assignments/${contractId}`);
    return response.data;
  },
  
  createAssignment: async (data) => {
    const response = await axios.post(`${API}/staff/assignments`, data);
    return response.data;
  },
  
  deleteAssignment: async (id) => {
    const response = await axios.delete(`${API}/staff/assignments/${id}`);
    return response.data;
  },
  
  suggestStaffCount: async (guestCount) => {
    const response = await axios.get(`${API}/staff/suggest/${guestCount}`);
    return response.data;
  },
  
  // New P1 enhancements
  checkAvailability: async (staffId, eventDate) => {
    const response = await axios.get(`${API}/staff/availability/${staffId}`, {
      params: { event_date: eventDate }
    });
    return response.data;
  },
  
  getDateConflicts: async (eventDate) => {
    const response = await axios.get(`${API}/staff/conflicts/${eventDate}`);
    return response.data;
  },
  
  getWorkload: async (month = null, year = null) => {
    const params = {};
    if (month) params.month = month;
    if (year) params.year = year;
    const response = await axios.get(`${API}/staff/workload`, { params });
    return response.data;
  },
  
  createBulkAssignments: async (contractId, eventDate, assignments) => {
    const response = await axios.post(`${API}/staff/assignments/bulk`, assignments, {
      params: { contract_id: contractId, event_date: eventDate }
    });
    return response.data;
  },
  
  getDayView: async (eventDate) => {
    const response = await axios.get(`${API}/staff/day-view/${eventDate}`);
    return response.data;
  }
};
